import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "./core/services/loginguard";
import { NoLoginGuard } from "./core/services/no-loginguard";
import { PageHomeComponent } from "./pages/page-home/page-home.component";
import { PageLoginComponent } from "./pages/page-login/page-login.component";
import { PageNotfoundComponent } from "./pages/page-notfound/page-notfound.component";
import { PageInfoComponent } from "./pages/page-info/page-info.component";
import { PageCarrinhoComponent } from "./pages/page-carrinho/page-carrinho.component";
import { PagePedidosComponent } from "./pages/page-pedidos/page-pedidos.component";
import { PageMeusDadosComponent } from "./pages/page-meus-dados/page-meus-dados.component";
import { PageCheckoutComponent } from "./pages/page-checkout/page-checkout.component";
import { PedidoImpressaoComponent } from "./pages/pedido-impressao/pedido-impressao.component";
import { PageNovoClienteComponent } from "./pages/page-novo-cliente/page-novo-cliente.component";
import { PageNovoRepresentanteComponent } from "./pages/page-novo-representante/page-novo-representante.component";
import { PageAprovaPedidoComponent } from "./pages/page-aprova-pedido/page-aprova-pedido.component";
import { DeactivateGuard } from "./core/services/deactivateguard";
import { PageMaterialMarketingComponent } from "./pages/material-marketing/page-material-marketing/page-material-marketing.component";
import { PageCatalogComponent } from "./modules/catalog/pages/page-catalog/page-catalog.component";
import { PageProdutoComponent } from "./modules/product/pages/page-produto/page-produto.component";
import { PageNewOrderComponent } from "./modules/order/page-new-order/page-new-order.component";
import { PageVendasComponent } from "./pages/page-vendas/page-vendas.component";
import { PageOrcamentoComponent } from "./pages/page-orcamento/page-orcamento.component";
import { PageRelatoriosComponent } from "./pages/page-relatorios/page-relatorios.component";
import { PageLinkPagamentoComponent } from "./pages/page-linkpagamento/page-linkpagamento.component";
import { PageAtivacaoComponent } from "./pages/page-ativacao/ativacao.component";
import { ListaPedidoB2cComponent } from "./pages/page-pedidos-b2c/lista-pedido-b2c.component";
import { PagePedidosWrapperComponent } from "./pages/page-pedidos-wrapper/page-pedidos-wrapper.component";
import { PageMeusDadosB2cComponent } from "./pages/page-meus-dados-b2c/page-meus-dados-b2c.component";
import { PageMeusDadosWrapperComponent } from "./pages/page-meus-dados-wrapper/page-meus-dados-wrapper.component";

const routes: Routes = [
  { path: "login", component: PageLoginComponent },
  { path: $localize`pedidoImpressao`, component: PedidoImpressaoComponent },
  { path: $localize`aprovaPedido`, component: PageAprovaPedidoComponent },
  { path: "notfound", component: PageNotfoundComponent },
  { path: "", component: PageHomeComponent, canActivate: [NoLoginGuard] },
  {
    path: "info/:pageId",
    component: PageInfoComponent,
  },
  {
    path: "ativacao/:hash",
    component: PageAtivacaoComponent,
  },
  {
    path: $localize`catalogo/:term`,
    component: PageCatalogComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`Relatorios`,
    component: PageRelatoriosComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`catalogo`,
    component: PageCatalogComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`linkpagamento/:token`,
    component: PageLinkPagamentoComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`orcamento`,
    component: PageOrcamentoComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`Historico`,
    component: PageVendasComponent,
    canActivate: [NoLoginGuard],
  },
  {
    path: $localize`produto/:id`,
    component: PageProdutoComponent,
    canActivate: [NoLoginGuard],
    canDeactivate: [DeactivateGuard],
  },
  {
    path: $localize`novo-pedido`,
    component: PageNewOrderComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`copia-pedido`,
    component: PageNewOrderComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`novo-cliente`,
    component: PageNovoClienteComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`Cadastro`,
    component: PageNovoRepresentanteComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`meus-dados`,
    component: PageMeusDadosWrapperComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`meus-dados/:id`,
    component: PageMeusDadosWrapperComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`pedidos`,
    component: PagePedidosWrapperComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "pedidos-b2c",
    component: ListaPedidoB2cComponent,
    canActivate: [LoginGuard],
  },
  {
    path: $localize`carrinho`,
    component: PageCarrinhoComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "checkout",
    component: PageCheckoutComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "material-marketing",
    component: PageMaterialMarketingComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "marketing",
    loadChildren: () =>
      import("./modules/marketing/marketing.module").then(
        (m) => m.MarketingModule
      ),
  },
  {
    path: "s",
    loadChildren: () =>
      import("./pages/page-share/page-share.module").then(
        (c) => c.PageShareModule
      ),
  },
  { path: "**", component: PageNotfoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      scrollOffset: [0, 0],
      // Enable scrolling to anchors
      anchorScrolling: "enabled",
      // relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
export const routingComponents = [
  PageHomeComponent,
  PageOrcamentoComponent,
  PageMeusDadosComponent,
  PageInfoComponent,
  PageMeusDadosB2cComponent,
  PageLoginComponent,
  PageCarrinhoComponent,
  PageCheckoutComponent,
  PageLinkPagamentoComponent,
  PagePedidosComponent,
  ListaPedidoB2cComponent,
  PageNotfoundComponent,
  PedidoImpressaoComponent,
  PageNovoClienteComponent,
  PageAprovaPedidoComponent,
  PageNovoRepresentanteComponent,
];
